// extracted by mini-css-extract-plugin
module.exports = {"queryInput":"AutocompleteSelection_queryInput__2-vdZ","suggestionsList":"AutocompleteSelection_suggestionsList__2ag8b"};